// import withReducer from 'store/withReducer'
import PatientFile from './container'
// import reducer from './module'

export default PatientFile
